import React from 'react';
import { jsx } from '@emotion/react';

/**
 * React Context which provides default event handlers
 * to link components such as IFL `<TextLink />` and `<ButtonLink />`.
 */
const LinkProviderContext = /*#__PURE__*/React.createContext({});

/**
 * React Context Provider which provides default event handlers to
 * decendent link components.
 */
const LinkProvider = _ref => {
  let {
    children,
    ...contextValue
  } = _ref;
  return jsx(LinkProviderContext.Provider, {
    value: contextValue
  }, children);
};
LinkProvider.displayName = "LinkProvider";

export { LinkProvider, LinkProviderContext };
